function isNull(x) {
    return x === null;
}

export { isNull };
